import React, { Component } from 'react';
import { Container, Card, Spinner, Row, Col, Button, Modal, Image } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import Paginate from '../_partials/Paginate/_Paginate';
import axios from 'axios';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link } from 'react-router-dom';
import { faAsterisk, faBook, faCalendarAlt, faClock, faExternalLink, faFileAlt, faLink, faPlay } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import { withParams } from '../../helpers/params_helper';
import ExamsCard from '../../helpers/ExamsCard';
import { GET } from '../../api/index';
import { AmericanGreen, Argent, Black, BlueCrayola, CerisePink, ColonialWhite, CyanProcess, LightSilver, OrangeRYB, PaleOyster, RedLustre, SpanishGray, VividMalachite, White, WhiteMarble, YaleBlue } from '../../helpers/brand_colors_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import GetIcon from '../../helpers/icon_helper';

const apiURL = process.env.REACT_APP_API_URL;
const portalURL = process.env.REACT_APP_PORTAL_URL;

/**
 * Exams Component
 */
class Exams extends Component {
  // State
  state = {
    exams: [],
    isRefreshing: false,
    limit: 12,
    totalRecords: 0,
    search: '',
    order: 'exams.exams_date',
    dir: 'DESC',
    examModalInfo: {
      show: false,
      data: null,
      toggle: (data = null) => this.setState({ examModalInfo: { ...this.state.examModalInfo, show: !this.state.examModalInfo.show, data } })
    }
  };

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.getExams();
  }

  /**
   * Get Exams
   */
  getExams = async (limit = this.state.limit, offset = 0) => {
    this.setState({ isRefreshing: true })
    const { authData, selectedChild } = this.props;

    const request_params = {
      child_id: selectedChild.child_id,
      is_homework: (this.props.is_homework) ? 1 : 0,
      limit: limit,
      offset: offset,
      // acs_id: (this.props.selectedSubject) ? this.props.selectedSubject.acs_id : null,
      class_id: selectedChild ? selectedChild.class_id : null,
      search: this.state.search,
      order: this.state.order,
      dir: this.state.dir
    };

    try {
      const res = await GET('exams/fetch-exams-table', {
        params: request_params,
      });

      this.setState({
        exams: res.data.data,
        totalRecords: parseInt(res.data.total_count_filtered),
        isRefreshing: false
      });
    } catch (err) {
      // console.log('err', err)
      toast.error(t('Something went wrong while fetching exams!'));

      this.setState({ isRefreshing: false })
    }
  };

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    // Language Direction
    const { lang_orientation: dir } = this.props.defaultLanguage;

    // State
    const { exams, isRefreshing, limit, totalRecords, page, search, examModalInfo } = this.state;
    const { is_homework } = this.props

    // Heading
    let heading = (is_homework) ? t('Homeworks') : t('Exams');
    // if (this.props.params.acs_name) {
    //   heading = (is_homework) ? t('Homeworks') : t('Exams') 
    // }

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={heading} backBtn={true} showChildSelector={true} func={[this.getExams]} />
            <div className='grey-section mb-0 p-0' style={{ height: '84vh', overflowY: 'auto' }}>
              {exams.length > 0 ? (
                <div className='d-flex flex-row flex-wrap p-1'>
                  {exams.map((v, index) => {
                    let data = {
                      allData: v,
                      name: v.exams_name,
                      code: (v.is_exampaper == 1) ? t('Paper') : t('Online'),
                      text1: v.examstype_name,
                      description: v.exams_notes,
                      cardImage: (v.acs_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + v.acs_image : require('../../assets/images/noimage.png'),
                      extraTexts: [],
                      actions: []
                    }
                    if (v.is_exampaper) {
                      data.actions.push({ text: 'Offline', backgroundColor: ColonialWhite, textColor: PaleOyster, iconName: 'LuCloudOff', onClick: () => examModalInfo.toggle(v) })
                    } else {
                      if ((is_homework && moment().isSameOrAfter(moment(v.exams_date + ' ' + v.open_time)) && moment().isSameOrBefore(moment(v.due_date + ' ' + v.close_time))) || (!is_homework && moment().isSameOrAfter(moment(v.exams_date + ' ' + v.open_time)) && moment().isSameOrBefore(moment(v.exams_date + ' ' + v.close_time)))) {
                        data.actions.push({ text: 'Start Attempt', backgroundColor: CyanProcess, textColor: White, iconName: 'FaPlay', onClick: () => examModalInfo.toggle(v) })
                      } else {
                        data.actions.push({ text: 'Start Attempt', backgroundColor: LightSilver, textColor: White, iconName: 'LuCloudOff' })
                      }
                    }



                    if (v.exams_attachment) {
                      data.extraTexts.push({ text: (v.exams_attachment.includes(".pdf")) ? 'Attached PDF' : t('Attached Image'), onClick: () => { window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/exams/' + v.exams_attachment, '_blank') }, iconName: 'LuLink2', textColor: CyanProcess })
                    }
                    let examDateTime = moment(v.exams_date + ' ' + v.open_time).format('DD-MM-YYYY HH:mm')
                    if (is_homework) {
                      examDateTime += ' - ' + moment(v.due_date + ' ' + v.close_time).format('DD-MM-YYYY HH:mm')
                    } else if (v.close_time) {
                      examDateTime += ' - ' + v.close_time

                    }
                    if (v.examsgrade && this.props.authData.userData.parent_status == 1) {
                      data.extraTexts.push({ text: (v.examsgrade.absence_id) ? 'Marked Absent: ' + v.examsgrade.absence_name : 'Graded: ' + v.examsgrade.examsgrade_grade + '/' + v.examsgrade.examsgrade_totalgrade, onClick: () => { }, iconName: 'LuBookCheck', textColor: VividMalachite })
                    }
                    data.extraTexts.push({ text: examDateTime, textColor: Argent, iconName: 'LuCalendar', onClick: () => { } })
                    return <ExamsCard data={data} key={index} />;
                  }
                  )}
                </div>
              ) : (
                <div style={{ height: '120px', flexDirection: 'column', }} className='d-flex justify-content-center align-items-center'>
                  <>
                    {isRefreshing && <span className='mb-1'>
                      <Spinner animation='grow' variant='dark' />
                    </span>
                    }
                    {!is_homework && (isRefreshing ? t('Fetching exams...') : t('No Exam Found'))}
                    {is_homework && (isRefreshing ? t('Fetching homeworks...') : t('No Homeworks Found'))}
                  </>
                </div>
              )}
              <div className='d-flex flex-row justify-content-end align-items-center px-3' style={{ backgroundColor: White }}>
                <Paginate
                  limit={this.state.limit}
                  totalRecords={this.state.totalRecords}
                  pageChange={this.getExams}
                  defaultTheme={this.props.defaultTheme}
                />
              </div>
            </div>
          </div>
        </div>
        {/* linkTo: '/attempt-exam/' + v.exams_id + '/' + (v.exam_retake_id ? v.exam_retake_id : 0) + '/' + is_homework, */}
        <Modal backdrop='static' keyboard={false} fullscreen show={examModalInfo.show} onHide={examModalInfo.toggle}>
          <Modal.Header closeButton>
            <div className='w-100 d-flex flex-row justify-content-between'>
              <div style={{ flex: 1 }}>
                <Modal.Title style={{ fontSize: 20 }}>
                  {examModalInfo.data?.exams_name}
                </Modal.Title>
              </div>
            </div>
          </Modal.Header>
          {examModalInfo.show &&
            <Modal.Body className='p-0 overflow-hidden'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                {/* LEFT */}
                <div style={{ width: '70%', minHeight: '85vh', height: '85vh', borderRight: 'solid 1px ' + WhiteMarble }} className='d-flex flex-column ps-3 pe-2'>
                  <div className='d-flex flex-row align-items-center'>
                    <div>
                      <Image src={(examModalInfo.data.acs_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + examModalInfo.data.acs_image : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', width: '100%', height: '9.5rem', backgroundColor: White, borderRadius: '1rem' }} />
                    </div>
                    <div className='d-flex flex-column'>
                      {/* due_date */}
                      <div style={{ fontWeight: 'bold', fontSize: 14 }} className='mb-1'>{examModalInfo.data.exams_name}</div>
                      <div className='d-flex flex-row align-items-center mb-1' style={{ color: SpanishGray }}>
                        <GetIcon icon="LuCalendar1" />
                        <div className='mx-2'>{moment(examModalInfo.data.exams_date).format('DD-MM-YYYY')}</div>
                        <div>{examModalInfo.data.open_time}</div>
                        <div>-</div>
                        <div>{examModalInfo.data.close_time}</div>
                      </div>
                      <div className='d-flex flex-row align-items-center mb-1'>
                        <div style={{ backgroundColor: CyanProcess, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center'>
                          {examModalInfo.data.acs_name}
                        </div>
                        <div style={{ backgroundColor: CerisePink, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center ms-2'>
                          {examModalInfo.data.examstype_name}
                        </div>
                      </div>
                    </div>
                  </div>
                  {examModalInfo.data.exams_notes &&
                    <div className='mt-2'>
                      <div style={{ fontWeight: '600' }}>Description</div>
                      <div>{examModalInfo.data.exams_notes}</div>
                    </div>
                  }
                  {examModalInfo.data.exams_attachment &&
                    <div className='d-flex flex-column align-items-start mt-2'>
                      <div style={{ fontWeight: '600' }}>Attachment</div>
                      <div style={{ border: 'solid 1px ' + WhiteMarble, borderRadius: 10 }} className='d-flex flex-row align-items-center p-2 cursor-pointer' onClick={() => window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/exams/' + examModalInfo.data.exams_attachment, '_blank')}>
                        <GetIcon icon={(examModalInfo.data.exams_attachment.includes(".pdf")) ? 'PiFilePdfFill' : 'PiFileImageFill'} style={{ fontSize: 20, color: examModalInfo.data.exams_attachment.includes(".pdf") ? RedLustre : AmericanGreen }} />
                        <div className='ms-1'>{(examModalInfo.data.exams_attachment.includes(".pdf")) ? 'Attached PDF' : t('Attached Image')}</div>
                      </div>
                    </div>
                  }
                </div>
                {/* RIGHT */}
                <div style={{ width: '30%', minHeight: '85vh', height: '85vh' }} className='d-flex position-relative'>
                  <div className='px-2' style={{ width: '100%' }}>
                    {examModalInfo.data.aslData.map((aslData_v, aslData_i) => {
                      return <div style={{ border: 'solid 1px ' + WhiteMarble, borderRadius: 10, width: '100%' }} className='d-flex flex-row align-items-center p-2 cursor-pointer my-2'>
                        <div style={{ borderRight: 'solid 1px ' + WhiteMarble }} className='pe-1 me-1'>
                          <Image src={(aslData_v.asl_attach) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + aslData_v.asl_attach : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', width: '70px', height: '100%', borderRadius: 5 }} />
                        </div>
                        <div className='ms-1' style={{ flex: 1 }}>
                          <div style={{ fontSize: 10, color: RedLustre }}>{aslData_v.asl_code}</div>
                          <div style={{ fontWeight: '600' }}>{aslData_v.asl_name}</div>
                        </div>
                        <div className='ms-1'>
                          <Link to={'/lesson-details/' + aslData_v.asl_id} state={{ lessonData: aslData_v }} style={{ textDecoration: 'none' }}  >
                            <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                          </Link>
                        </div>
                      </div>
                    })}
                  </div>
                </div>
              </div>


            </Modal.Body>
          }
          {examModalInfo.show &&
            <Modal.Footer>
              <div className='d-flex flex-row justify-content-end align-items-center'>
                <div className='d-flex flex-row align-items-center justify-content-center cursor-pointer p-2 mb-2' style={{ borderRadius: '0.5rem', backgroundColor: CerisePink, color: White }} onClick={() => examModalInfo.toggle()} >
                  <div className='ms-1'>{t('Close')}</div>
                </div>
                {!examModalInfo.data.is_exampaper &&
                  <Link to={'/attempt-exam/' + examModalInfo.data.exams_id + '/' + (examModalInfo.data.exam_retake_id ? examModalInfo.data.exam_retake_id : 0) + '/' + this.props.is_homework} style={{ textDecoration: 'none' }}>
                    <div className='d-flex flex-row align-items-center justify-content-center cursor-pointer p-2 mb-2 mx-3' style={{ borderRadius: '0.5rem', backgroundColor: CyanProcess, color: White }}  >
                      <GetIcon icon={'FaPlay'} />
                      <div className='ms-1'>{t('Start Attempt')}</div>
                    </div>
                  </Link>
                }
              </div>
            </Modal.Footer>
          }
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
});
export default connect(mapStateToProps, null)(withParams(Exams));
